import React, { useEffect, useState, useRef } from "react";
import { Table, Modal, Spinner } from "react-bootstrap";
import axios from "axios";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import Baseurl from "../../../Baseurl";
export default function ViewPartner(props) {
  const [onboardUser, setOnBoardUser] = useState([]);
  const [show, setShow] = useState(false);
  const [spinner, setSpinner] = useState(false);
  const [image, setImage] = useState(null);
  const [auto, setAuto] = useState("");
  const [bike, setBike] = useState("");
  const [threewheel, setThreeWheel] = useState("");
  const [tataAce, setTataAce] = useState("");
  const [pickUp, setPickUp] = useState("");
  const [tata407, setTata407] = useState("");
  const [suv, setSuv] = useState("");
  const [sedan, setSedan] = useState("");
  const [hatchBack, setHatchBack] = useState("");
  const { id } = props.match.params;
  var nameObject = [
    { name:"Auto",
     value:auto,
     setValue:setAuto,
     },
     { name:"Bike",
     value:bike,
     setValue:setBike,
     },
     { name:"3 Wheeler",
     value:threewheel,
     setValue:setThreeWheel,
     },
     { name:"Tata Ace",
     value:tataAce,
     setValue:setTataAce,
     },
     { name:"PickUp 8ft",
     value:pickUp,
     setValue:setPickUp,
     },
     { name:"Tata 407",
     value:tata407,
     setValue:setTata407,
     },
     { name:"SUV/MUV",
     value:suv,
     setValue:setSuv,
     },
     { name:"Sedan",
     value:sedan,
     setValue:setSedan,
     
     },
     { name:"Hatch Back",
     value:hatchBack,
     setValue:setHatchBack,
     },
  ];
  const history = useHistory();
  function getData() {
    axios
      .get(`${Baseurl.baseurl}/onboarding/get-onboarding-by-id/${id}`)
      .then((res) => {
        setOnBoardUser(res.data.onboarding);
     console.log('dndndndddddd',res.data.onboarding)
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  useEffect(() => {
    getData();
  }, []);
  function viewImage(img) {
    setShow(true);
    setImage(img);
  }
  function approveCenter() {
    if (onboardUser.CommissionModel) {
      setSpinner(true);
      axios
        .put(
          `${Baseurl.baseurl}/onboarding/approve-onboarding-center/${id}`
        )
        .then((response) => {
          setSpinner(false);
          if (response.data.status) {
            swal("Approved", response.data.message, "success", {
              button: "Done",
              timer: 1000,
            });
            history.push("/partner");
          } else {
            swal("Oops", response.data.message, "error", {
              button: "Done",
              timer: 1000,
            });
          }
        })
        .catch((err) => {
          if (err.toString() === "Error: Network Error") {
            history.push("/offline");
          } else {
            history.push("/400");
          }
        });
    } else {
      swal("Oops", "Please Add Commision", "error", {
        button: "Done",
        timer: 1000,
      });
    }
  }
  // const Add = () => {
  //   let cmm = parseInt(commission);
  //   const vehicle1 = {
  //     VehicleType: vehicleName,
  //     VehicleCommission: cmm,
  //   };
  //   setpushvehicle(
  //     (oldArray) => oldArray.concat(vehicle1),
  //     () => {}
  //   );
  //   setCommission("");
  //   setVehicleName("");
  //   swal("Added", "Added successfully", "success", {
  //     showCancelButton: true,
  //     timer: 1000,
  //   });
  // };  

  function submitHandler(e) {
     e.preventDefault()
    // let comm;
    // nameObject.map((val)=>{
    //   comm.push({VehicleType:val.name,VehicleCommission:parseInt(val.value)})
    // })
    const artical = {
      CommissionModel:[
        { VehicleType:"Auto",
        VehicleCommission:auto,
        },
        { VehicleType:"Bike",
        VehicleCommission:bike,
        },
        { VehicleType:"3 Wheeler",
        VehicleCommission:threewheel,
        },
        { VehicleType:"Tata Ace",
        VehicleCommission:tataAce,
        },
        { VehicleType:"PickUp 8ft",
        VehicleCommission:pickUp,
        },
        { VehicleType:"Tata 407",
        VehicleCommission:tata407,
        },
        { VehicleType:"SUV/MUV",
        VehicleCommission:suv,
        },
        { VehicleType:"Sedan",
        VehicleCommission:sedan,
        },
        { VehicleType:"Hatch Back",
        VehicleCommission:hatchBack,
        },
      ]
    };
    axios
      .put(
        `${Baseurl.baseurl}/onboarding/add-onboarding-commission/${id}`,
        artical
      )
      .then((response) => {
        if (response.data.status) {
          swal("Commission Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          getData();
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Try Again!",
            timer: 1000,
          });
        }
        
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  return (
    <div
      className="card"
      style={{
        color: "white",
        background:
          "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
      }}
    >
      <Modal
        size="lg"
        show={show}
        onHide={() => {
          setShow(false);
        }}
      >
        <Modal.Body>
          <div>
            <img
            alt=""
              style={{
                resizeMode: "cover",
                width: "100%",
                height: "100%",
              }}
              className="playerProfilePic_home_tile"
              src={image}
            />
          </div>
        </Modal.Body>
      </Modal>
      <div className="card-header">
        <div className="card-title text-white">Partner Details</div>
        <button
          onClick={() => {
            history.goBack();
          }}
          className="btn btn-primary"
        >
          Back
        </button>
      </div>
      <div className="card-body">
        <Table className="text-white">
          <tbody></tbody>
          <tr>
            <td>Name</td>
            <td>{onboardUser.Name}</td>
          </tr>
          <tr>
            <td>Email</td>
            <td>{onboardUser.Email}</td>
          </tr>
          <tr>
            <td>Phone</td>
            <td>{onboardUser.Phone}</td>
          </tr>
          <tr>
            <td>Company Code</td>
            <td>{onboardUser.CompanyCode}</td>
          </tr>
          <tr>
            <td>Address</td>
            <td>{onboardUser.OfficeAddress}</td>
          </tr>
          <tr>
            <td>Pincode</td>
            <td>{onboardUser.OfficePincode}</td>
          </tr>

          <tr>
            <td>Adhar Number</td>
            <td>{onboardUser.AadhaarNumber}</td>
          </tr>
          <tr>
            <td>Entity Type</td>
            <td>{onboardUser.EntityType}</td>
          </tr>
          {onboardUser.BankAccountDetails&& onboardUser.BankAccountDetails.AccountIFSC&&(
             <>
             <tr>
             <td>Bank Account Name</td>
             <td>
               {
                 onboardUser.BankAccountDetails.AccountName}
             </td>
           </tr>
           <tr>
             <td>Bank Account Number</td>
             <td>
               {
                 onboardUser.BankAccountDetails.AccountNumber}
             </td>
           </tr>
           <tr>
             <td>Bank Account IFSC</td>
             <td>
               {
                 onboardUser.BankAccountDetails.AccountIFSC}
             </td>
           </tr></>
          )}
         
          <tr>
            <td>Bank Account Status</td>
            <td>{onboardUser.BankStatus ? "Verified" : "Not Verified"}</td>
          </tr>
          <tr>
            <td>PAN Image</td>
            <td>
              <div
                onClick={() => {
                  viewImage(onboardUser.PANImage);
                }}
                style={{
                  marginTop: "5px",
                  width: 180,
                  height: 100,
                  aspectRatio: 1 * 1.4,
                }}
              >
                <img
                alt=""
                  src={onboardUser.PANImage}
                  style={{
                    resizeMode: "cover",
                    width: "100%",
                    height: "100%",
                  }}
                />
              </div>
            </td>
          </tr>
          <tr>
            <td>Company Proof Image</td>
            <td>
              <div
                onClick={() => {
                  viewImage(onboardUser.CompanyProofImage);
                }}
                style={{
                  marginTop: "5px",
                  width: 180,
                  height: 100,
                  aspectRatio: 1 * 1.4,
                }}
              >
                <img
                alt=""
                  src={onboardUser.CompanyProofImage}
                  style={{
                    resizeMode: "cover",
                    width: "100%",
                    height: "100%",
                  }}
                />
              </div>
            </td>
          </tr>
          <tr>
            <td>Form Image</td>
            <td>
              <div
                onClick={() => {
                  viewImage(onboardUser.FormImage);
                }}
                style={{
                  marginTop: "5px",
                  width: 180,
                  height: 100,
                  aspectRatio: 1 * 1.4,
                }}
              >
                <img
                alt=""
                  src={onboardUser.FormImage}
                  style={{
                    resizeMode: "cover",
                    width: "100%",
                    height: "100%",
                  }}
                />
              </div>
            </td>
          </tr>
          {!onboardUser.OnboardingVerified && (onboardUser.CommissionModel===undefined||onboardUser.CommissionModel.length===0)&&onboardUser.OnboardingType!=="Restaurant"&&(
            <tr>
              <td>Add Commission</td>
              <td>
                <form onSubmit={(e) => submitHandler(e)}>
                  {nameObject.map((val)=>{
                    return(
                      <div className="form-group row">
                      <label className="col-sm-3 col-form-label">{val.name}</label>
                      <div className="col-sm-4">
                        <input
                        onWheel={(e) => e.target.blur()}
                          type="number"
                          className="form-control"
                          onChange={(e) => val.setValue(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    )
                  })}
                   <div className="form-group row">
                      <label className="col-sm-3 col-form-label"></label>
                      <div className="col-sm-4 text-center">
                      <button className="btn btn-primary">ADD</button>
                      </div>
                    </div>
                  
                </form>
              </td>
            </tr>
          )}
        </Table>
      </div>
      {!onboardUser.Verified && (
        <div className="card-footer">
          {spinner ? (
            <Spinner
              className="float-right"
              animation="border"
              variant="primary"
            />
          ) : (
            <button
              className="btn btn-primary float-right"
              onClick={() => {
                approveCenter();
              }}
            >
              Approve
            </button>
          )}
        </div>
      )}
    </div>
  );
}
